import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import {shouldUseMobileApp} from './platform';

// Build-time force (REACT_APP_TARGET) still tree-shakes one UI away.
// Otherwise runtime detection picks MobileApp for mobile browsers.
const forcedTarget = process.env.REACT_APP_TARGET;
let isMobileTarget;
let App;

if (forcedTarget === 'mobile') {
  isMobileTarget = true;
  App = require('./mobile/MobileApp').default;
} else if (forcedTarget === 'desktop') {
  isMobileTarget = false;
  App = require('./App').default;
} else {
  isMobileTarget = shouldUseMobileApp();
  App = isMobileTarget
    ? require('./mobile/MobileApp').default
    : require('./App').default;
}

if (isMobileTarget) {
  document.documentElement.classList.add('mobile-target');
  document.body.classList.add('mobile-target');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
